import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const autenticado = await this.authService.estaAutenticado();
    
    if (!autenticado) {
      this.router.navigate(['/sesion']);
      return false;
    }

    // Verificar tipo de usuario si la ruta lo requiere
    const tipoRequerido = route.data['tipoUsuario'];
    
    if (tipoRequerido) {
      const usuario = this.authService.getUsuarioActual();
      
      if (usuario && usuario.tipo !== tipoRequerido) {
        // Redirigir a la página correspondiente según su tipo
        if (usuario.tipo === 'organizacion') {
          this.router.navigate(['/comunidad']);
        } else if (usuario.tipo === 'plataforma_general') {
          this.router.navigate(['/home']);
        }
        return false;
      }
    }
    
    return true;
  }
}
